
import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

interface LinkItem {
  label: string;
  url: string;
  isExternal?: boolean;
  renderCustom?: React.ReactNode;
}

interface FooterLinksProps {
  title: string;
  links: Array<LinkItem>;
}

const FooterLinks: React.FC<FooterLinksProps> = ({ title, links }) => {
  return (
    <div>
      <h3 className="text-primary-blue font-semibold mb-3">{title}</h3>
      <ul className="space-y-2">
        {links.map((link, index) => (
          <li key={index} className="text-gray-600">
            {link.renderCustom ? (
              link.renderCustom
            ) : link.isExternal ? (
              <a 
                href={link.url} 
                className="hover:text-primary-blue transition-colors flex items-center gap-1"
                target="_blank"
                rel="noopener noreferrer"
              >
                {link.label}
                <ExternalLink className="h-3.5 w-3.5" />
              </a>
            ) : (
              <Link 
                to={link.url} 
                className="hover:text-primary-blue transition-colors"
              >
                {link.label}
              </Link>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FooterLinks;
